<template>
    <template v-if="type == 'plugin.header'">
        <section id="header__section">
        <div class="container">
            <div class="header__top">
            <div class="header__top--left">
                <div style="width: 128px; height: 128px" class="placeholder"></div>
                <div class="header__left--meta">
                <h1 class="placeholder">&nbsp;</h1>
                    <span class="placeholder creator" v-for="i in 3" :key="i">&nbsp;</span>
                </div>
            </div>
            <div class="header__top--right">
                <div class="download__wrapper">
                <a class="btn placeholder">&nbsp;</a>
                </div>
            </div>
            </div>
            <div class="header__bottom">
            <div class="tabs">
                <div v-for="i in 3" :key="i" class="tab__entry placeholder"></div>
            </div>
            </div>
        </div>
        </section>
    </template>
    <template v-if="type == 'page.overview'">
        <div class="container grid grid--9-3 grid--offset-big">
        <section class="overview">
            <h2 class="placeholder">&nbsp;</h2>
            <div class="tab__wrapper">
            <div class="tab__content--bottom">
                <div class="tab__entry">
                <div v-for="i in 3" :key="i" class="description placeholder">&nbsp;</div>
                </div>
            </div>
            </div>
        </section>
        <aside class="meta">
            <div v-for="i in 5" :key="i" class="meta__entry">
                <h4 class="placeholder">&nbsp;</h4>
                <span class="placeholder">&nbsp;</span>
            </div>
        </aside>
        </div>
    </template>
    <template v-if="type == 'page.support'">
        <section class="support__wrapper">
            <div class="support__top">
                <div class="container">
                    <div style="width:100%;height:375px;" class="placeholder"></div>
                </div>
            </div>
        </section>
    </template>
    <template v-if="type == 'page.creator'">
        <h3 class="placeholder">&nbsp;</h3>
        <div v-for="i in 8" :key="i" style="height:73px;margin-bottom: 5px;" class="placeholder"></div>
    </template>
    <template v-if="type == 'page.creator_listing'">
        <div class="container">
            <div class="creator">
                <div class="left">
                    <a v-for="i in 2" :key="i" class="creator__link placeholder">&nbsp;</a>
                </div>
                <div class="right">
                    <div class="plugin__header">
                    <h2 class="placeholder">&nbsp;</h2>
                    </div>
                    <div>
                        <div class="listing__category" v-for="i in 3" :key="i">
                            <h3 class="placeholder">&nbsp;</h3>
                            <label class="placeholder">&nbsp;</label>
                            <div v-for="a in 3" :key="a" style="height: 50px;margin-bottom:10px;" class="placeholder"></div>
                        </div>
                    </div>
                    <a class="btn btn--save placeholder"></a>
                </div>
            </div>
        </div>
    </template>
    <template v-if="type == 'creator.header'">
        <section id="header__section">
        <div class="container">
            <div class="header__top">
                <div class="header__top--left">
                    <div style="width: 128px; height: 128px" class="placeholder"></div>
                    <div class="header__left--meta">
                    <h1 class="placeholder">&nbsp;</h1>
                        <span class="placeholder" v-for="i in 5" :key="i">&nbsp;</span>
                    </div>
                </div>
            </div>
        </div>
        </section>
    </template>
</template>

<script>
    export default {
        data() {
            return {};
        },

        props: {
            type: {
            type: String,
            required: true,
            },
        },
    };
    </script>

<style lang="scss" scoped>
    .placeholder {
        background-color: #f4f4f4;
        border-color: #f4f4f4;
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
        0% {
            background-color: #f4f4f4;
            border-color: #f4f4f4;
        }

        70% {
            background-color: #efefef;
            border-color: #efefef;
        }

        100% {
            background-color: #f4f4f4;
            border-color: #f4f4f4;
        }
    }

    @keyframes pulse-border {
        0% {
            border-color: #f4f4f4;
        }

        70% {
            border-color: #efefef;
        }

        100% {
            border-color: #f4f4f4;
        }
    }

    h1.placeholder,
    h2.placeholder,
    h3.placeholder,
    h4.placeholder {
        width: 75%;
    }

    span.placeholder {
        width: 150px;
    }

    #header__section {
        animation: pulse-border 2s infinite;
    }

    .description.placeholder {
        height: 300px;
        margin-bottom: 30px;
    }

    .tabs {
        display: flex;
        justify-content: space-between;

        .tab__entry {
            height: 41px;
            width: 100%;
            max-width: 400px;
            margin: 0 20px;
        }
    }

    .creator{
        height: 100%;

        .left{
            width: 240px;
            display: inline-block;
            background-color: #f4f4f4;
            padding: 55px 25px 50px 0;
            box-sizing: border-box;
            height: 100%;
        }

        .right{
            width: calc(100% - 240px);
            padding: 40px 25px;
            display: inline-block;
            box-sizing: border-box;
            vertical-align: top;
            height: 100%;
        }


        label.placeholder{
            width: 30%;
            display: inline-block;
            margin-bottom: 10px;
        }
    }
</style>